import { useState } from "react";
import { Box } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import {
  SaveButton,
  SimpleForm,
  Toolbar,
  useDataProvider,
  useEditController,
  useNotify,
  useRedirect,
  Button,
  useCreate,
} from "react-admin";
import { SubmitHandler } from "react-hook-form";
import { CrmDataProvider } from "../providers/types";
import { SalesFormData } from "../types";
import { ScmAnalysesInput } from "./ScmAnalysesInput";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import ScmFechamentoDialog from "./ScmDialogFechamento";

export function ScmAnalyses() {
  // Movi o botão pra dentro pra conseguir chamar a função do POST
  function EditToolbar() {
    return (
      <Toolbar
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 1000,
        }}
      >
        <Box
          display="flex"
          width="100%"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <Box mr={{ sm: "0.5em" }}>
            <SaveButton />
          </Box>
          <Box mr={{ sm: "0.5em" }}>
            <Button
              onClick={handleMove}
              label="Salvar Info"
              color="primary"
              variant="outlined"
              size="medium"
              disabled={!SKU}
            >
              <SaveAsIcon />
            </Button>
          </Box>
          <Box mr={{ sm: "0.5em" }}>
            <ScmFechamentoDialog />
          </Box>
          <Box flex={1} mr={{ sm: "0.5em" }}>
            <p style={{ marginTop: "0.6em" }}>
              Linha Selecionada: {itemSelecionado + 1}/{quantidadeItens}
            </p>
          </Box>
          <Box
            flex={1}
            mr={{ sm: "3.5em" }}
            sx={{
              display: "flex",
              justifyContent: "flex-end", // mantém à direita
              alignItems: "center", // centraliza verticalmente
            }}
          >
            <p style={{ fontWeight: "bold" }}>
              Total Previsto:{" "}
              {record?.total_previsto?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </p>
          </Box>
        </Box>
      </Toolbar>
    );
  }

  const { record } = useEditController();
  const dataProvider = useDataProvider<CrmDataProvider>();
  const notify = useNotify();
  const redirect = useRedirect();
  const [create] = useCreate();
  const [SKU, setSku] = useState(0);
  const [infoSku, setInfoSku] = useState<any[]>([]);
  // Este campo PEDIDO é a coluna pedido de cima, ou seja, deixa true pra que seja feito o GET para atualizar o dado de cima
  const [atualizaCampoPedido, setAtualizaCampoPedido] = useState(false);
  const [linhaSalva, setlinhaSalva] = useState(false);

  // Item Selecionado
  const [itemSelecionado, setItemSelecionado] = useState<number>(1);

  // Quantidade de Itens do Grid
  const [quantidadeItens, setQuantidadeItens] = useState<number>(0);

  const handleItemSelecionado = (itemId: number) => {
    setItemSelecionado(itemId);
  };

  const handleQtdItens = (itemId: number) => {
    setQuantidadeItens(itemId);
  };

  const handleLinhaSalvaConsumida = () => {
    setlinhaSalva(false); // Reseta o estado para liberar o fluxo normal
  };

  //   console.log("record", record);

  // Tentativa de copnseguir o SKU para do filho
  const handleSkuChange = (newSku: number, info: any[]) => {
    setSku(newSku);
    setInfoSku(info);
  };

  const { mutate } = useMutation({
    mutationKey: ["signup"],
    mutationFn: async (data: SalesFormData) => {
      if (!record) {
        throw new Error("Record not found");
      }
      return dataProvider.update("scmanalyses", {
        id: record.id,
        data: data,
        previousData: record,
      });
    },
    onSuccess: () => {
      // redirect("/scmanalyses");
    },
    onError: () => {
      notify("An error occurred. Please try again.");
    },
  });

  const onSubmit: SubmitHandler<SalesFormData> = async (data) => {
    mutate(data);
  };

  //   POST
  // Aqui vou fazer o tratamento para dar o POST
  const handleMove = () => {
    const itens = record?.itens || [];

    // Aqui faz o POST
    const payload = {
      id_analise: record?.id,
      codigo_sku: SKU,
      info_sku: infoSku,
    };

    create(
      "scmestimates",
      { data: payload },
      {
        onSuccess: () => {
          setAtualizaCampoPedido(true);
          setlinhaSalva(true);
          notify("Informações salvas", { type: "success" });
          setTimeout(() => {
            setAtualizaCampoPedido(false);
          }, 300);
        },
        onError: (error: any) => {
          notify(error?.message || "Erro ao salvar as informações", {
            type: "error",
          });
        },
      }
    );
  };

  return (
    <SimpleForm
      toolbar={<EditToolbar />}
      onSubmit={onSubmit as SubmitHandler<any>}
      record={record}
      sx={{ mt: 0, pt: 0 }}
    >
      <ScmAnalysesInput
        onSkuChange={handleSkuChange}
        atualizaCampoPedido={atualizaCampoPedido}
        itemSelecionadoChange={handleItemSelecionado}
        qtdTotalItens={handleQtdItens}
        linhaSalva={linhaSalva}
        onLinhaSalvaConsumida={handleLinhaSalvaConsumida}
      />
    </SimpleForm>
  );
}
